//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['to', 'isLink', 'icon'],
  methods: {
    handle() {
      if (this.to) {
        this.$router.push(this.to)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/cell.vue